<template>
  <div id="wrapper">
      <RTHeader/>
      <RTNavigation/>
      <div id="main">
        <div class="inner">
          <section> 
              <div class="text-center">
                <h1>Vielen Dank für deine Unterstützung</h1>
                <p>
                  Durch deine großzügige Unterstützung trägst du maßgeblich dazu bei, dass ehrenamtliche Projekte wachsen und bestehen bleiben können – dafür ein herzliches Dankeschön!
                </p>
                <p style="text-align:center;">
                  <!-- Großer Thank You Emoji -->
                  <span style="font-size: 4rem;">🙏</span>
                </p>
                <p class="mt-5"><a href="/">Zurück zur Übersicht</a></p>
              </div>
            <!-- Konfetti-Animation -->
            <canvas ref="confettiCanvas" class="confetti-canvas"></canvas>
          </section>
      </div>
    </div>
  </div>
</template>

<script>
import confetti from "canvas-confetti";
import RTHeader from '@/components/RTHeader.vue'
import RTNavigation from '@/components/RTNavigation.vue'

export default {
  components: {
		RTHeader,
		RTNavigation,
	},
  mounted() {
    this.startCelebration();
  },
  unmounted() {
    clearInterval(this.interval);
  },
  methods: {
    fire(particleRatio, opts) {
      const count = 200;
      const defaults = {
        origin: { y: 0.7 },
      };

      confetti({
        ...defaults,
        ...opts,
        particleCount: Math.floor(count * particleRatio),
      });
    },
    launchConfetti() {
      this.fire(0.25, {
        spread: 26,
        startVelocity: 55,
      });
      this.fire(0.2, {
        spread: 60,
      });
      this.fire(0.35, {
        spread: 100,
        decay: 0.91,
        scalar: 0.8,
      });
      this.fire(0.1, {
        spread: 120,
        startVelocity: 25,
        decay: 0.92,
        scalar: 1.2,
      });
      this.fire(0.1, {
        spread: 120,
        startVelocity: 45,
      });
    },
    startCelebration() {
      // Startet die Animation und wiederholt sie alle 3 Sekunden
      this.launchConfetti();
      this.interval = setInterval(() => {
        this.launchConfetti();
      }, 3000);
    },
  },
  beforeDestroy() {
    // Räumt das Intervall auf, um Speicherlecks zu vermeiden
    clearInterval(this.interval);
  },
};
</script>

<style scoped>
.confetti-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
</style>
